const paymentDetailsFormResources = {
    labelMonthlyDues: 'Monthly Dues',
    captionPaymentOnFirstOfEveryMonth: '* Payment on the 1st of every month',
    labelTodaysPayment: 'Today\'s Payment',
    labelTodaysTotalPayment: 'Today\'s Total Payment',
    labelMonthlyReimbursements: 'Monthly Reimbursements',
    captionPaymentAfterTwentyFifthOfEveryMonth: '* Payment after 25th of every month',
    labelRequiredVisits: 'Required Visits'
};
export default paymentDetailsFormResources;